/* eslint-disable camelcase */

export enum NotifyAction {
    Ready = 'ready',
    UpdateAIResult = 'updateAIResult',
    ConditionChange = 'conditionChange',
    ScoreChange = 'scoreChange',
    RatingLoading = 'ratingLoading',
    RatingFailed = 'ratingFailed',
    RatingEmpty = 'ratingEmpty',
    SocketError = 'socketError',
    HasNewRating = 'hasNewRating',

}

export enum CorrectType {
    Correct = 'correct',
    LongSentence = 'longSentence',
    LongParagraph = 'longParagraph',
    Mindmap = 'list2mindmap',
    FormatOptimize = 'formatOptimize',
    Evaluation = 'evaluation',
}

// 分组类型
export enum GroupType {
    Suggest = 'suggest',
    Correct = 'correct',
    Readability = 'readability',
}

// 错误类型，包括: 错别字、标点错误、语法错误
export enum TextErrorType {
    ErrorWord = 'errorWord',
    ErrorPunctuation = 'errorPunctuation',
    ErrorYuFa = 'errorYuFa',
}

export interface OptimizeObj {
    id: string;
    // 优化类型, 包括: 错别字优化、长句优化、长段落优化
    type: CorrectType;
    // 标记来源 文心/小模型
    source: 'wenxin' | 'nlp';
    operation: 'insert' | 'delete' | 'replace';
    origin_text_str: string;
    origin_text: string;
    origin_sentence: string;
    fixed_text: string;
    fixed_sentence: string;
    sentence_offset?: number;
    evaluation?: string;
    hovers?: Array<{
        originContent: string;
        shortContent: string;
        hover: boolean;
    }>;
    classify?: string;
    items?: Array<Record<string, any>>;
    suggestionNum?: number;
    recommendDocs?: Array<{title: string, link: string}>;
    like?: -1 | 0 | 1;
    category?: TextErrorType;
    // 错误说明
    reason?: string;
    // 格式优化类型
    formatType?: string;
}

export interface AIGCInstance {
    [key: string]: any;
}

export enum GradeStatus {
    Init = 'init',
    Gradable = 'gradable',
    NoGradable = 'noGradable',
    NoHistory = 'noHistory',
    Success = 'success',
    Failed = 'failed',
    Loading = 'loading',
}

export interface AIAgentData {
    docDomReady: boolean;
    // AIGC插件是否加载完成
    AIGCPluginReady: boolean;
    AIGCInstanceRef: React.MutableRefObject<AIGCInstance | null>;
    // 文档字数
    wordCount: number;
    // 评分状态
    gradeStatus: GradeStatus;
    // 评分中
    grading: boolean;
    // 手动触发评分
    manualGrade: boolean;
    // 分数
    score: number | null;
    // 分数更新类型，采纳、忽略、请求
    scoreUpdateType: 'apply' | 'ignore' | 'request';
    // 有新的评分生成
    hasNewGrade: boolean;
    // 优化建议列表
    optimizeList: OptimizeObj[];
    // 列表更新类型，采纳、忽略、请求
    updateType: 'apply' | 'ignore' | 'request';
    // Socket 错误
    socketError: boolean;
    // 不进行提示
    noTips: boolean;
}

export interface IMindMapModalData {
    // 是否显示预览层
    visible: boolean;
    // 预览图类型，list: 列表 mindMap: 脑图
    type: 'list' | 'mindMap';
    mindmapSvg: string;
    listMd: string;
    width: number;
    height: number;
}
